import { Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useTranslation } from '../../../../../../../i18next';
import { callFirebaseFunction } from '../../../../../../../services/firebaseFunctions';
import { PageOAuthRedirectContainer } from '../../../../../../OAuth/pages/Redirect';

export const PageSlackOAuthRedirect = ({ slackId }: { slackId: string }) => {
  // just notify the person, that they just received a message in slack, where they should
  // finish the installation process.
  // we also need to trigger sending this message out from here, because
  // otherwise we have no chance to actually identify who the user is (we would end up
  // with the original problem of not knowing how to link the slack oauth to a dado account)

  const { t } = useTranslation();

  useEffect(() => {
    callFirebaseFunction('integrations_slack-sendInstallationWrapUpMessage', {
      slackId
    });
    // handle error
  }, [slackId]);
  return (
    <PageOAuthRedirectContainer>
      <div>
        <Typography component="h3" variant="h3">
          {t('org.integrations.slack.finishSetupInSlack.heading')}
        </Typography>
        <br />
        <div>{t('org.integrations.slack.finishSetupInSlack.p')}</div>
      </div>
    </PageOAuthRedirectContainer>
  );
};
